var map = {
	"./arrow-down.svg": "6ba9",
	"./arrow-left.svg": "f21f",
	"./arrow-left2.svg": "f454",
	"./arrow-right.svg": "3743",
	"./arrow-up.svg": "86dc",
	"./backer.svg": "065b",
	"./circle-picture.svg": "a2dd",
	"./circle-text.svg": "dbfa",
	"./clock.svg": "b4b0",
	"./close.svg": "d8e4",
	"./collect.svg": "a4aa",
	"./comment.svg": "dda7",
	"./list.svg": "765e",
	"./listen.svg": "0f24",
	"./live.svg": "3025",
	"./locate.svg": "bfe2",
	"./mail.svg": "2b16",
	"./menu.svg": "11d0",
	"./msg.svg": "c7ec",
	"./organizer.svg": "a3f9",
	"./phone.svg": "86c9",
	"./play.svg": "9604",
	"./praise.svg": "2ea8",
	"./prize.svg": "daec",
	"./replay.svg": "e06d",
	"./selection.svg": "a585",
	"./share.svg": "1ff0",
	"./sponsor.svg": "8b16",
	"./text.svg": "5940",
	"./time.svg": "bc82",
	"./users.svg": "56fe",
	"./vote.svg": "4fc1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3a23";